import { langs } from "helpers/lang";
import {
  EXTERNAL_ROUTES,
  ExternalRouteKeys,
  RouteKeys,
  ROUTES,
} from "helpers/routes";
import { Language } from "interfaces/locale";
import useLanguage from "./useLanguage";

const useLocalizedRoutes = () => {
  const language = useLanguage();
  const lang: Language = language ?? langs.pt;

  const getLanguageRoute = (routeKey: RouteKeys) => {
    const langLink = language === langs.pt ? "" : `/${lang}`;

    return `${langLink}${ROUTES[lang][routeKey]}`;
  };

  const getExternalLanguageRoute = (externalRouteKeys: ExternalRouteKeys) => {
    return EXTERNAL_ROUTES[lang][externalRouteKeys];
  };

  return { getLanguageRoute, getExternalLanguageRoute };
};

export default useLocalizedRoutes;
